import Vue from 'www/vue_components'
import ClubLpuPriceSwitcher from 'www/vue_components/common/Club/components/dependencies/ClubLpuPriceSwitcher/components/ClubLpuPriceSwitcher.vue'
import { CLUB_ATTRS } from 'www/vue_components/common/Club/components/dependencies/ClubLpuPriceSwitcher/constants'

const componentPropsValue = document.querySelector(`[${CLUB_ATTRS.context}]`)?.getAttribute(CLUB_ATTRS.context)

if (componentPropsValue) {
  try {
    const props = JSON.parse(componentPropsValue)

    new Vue({
      el: '.vue-lpu-price-switcher',
      render: h => h(ClubLpuPriceSwitcher, { props }),
    })
  } catch { /* Empty */ }
}
